/* Read the current URL at interaction time: Dawn can update filters without
   re-rendering the collection header. No engine choice is stored globally. */
(() => {
  if (window.emaEngineLinksReady) return;
  window.emaEngineLinksReady = true;
  const key = 'filter.p.m.custom.compatible_engine_families';
  const update = (event) => {
    const link = event.target.closest('a[data-ema-engine-link]');
    if (!link) return;
    const target = new URL(link.href, window.location.origin);
    target.searchParams.delete(key);
    if (link.dataset.emaEngineLink === 'filtered') {
      new URLSearchParams(window.location.search).getAll(key).forEach(value => {
        if (value) target.searchParams.append(key, value);
      });
    }
    link.href = target.pathname + target.search + target.hash;
  };
  ['click', 'auxclick', 'contextmenu', 'focusin', 'pointerover'].forEach(type => {
    document.addEventListener(type, update, true);
  });
})();
